/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { CustomerUsersTableUserFragmentDoc } from '../../../../../../components/organization/CustomerUsersTable/__generated__/CustomerUsersTable.graphql';
import { CustomerSubscriptionsTableSubscriptionFragmentDoc } from '../../../../../../components/organization/CustomerSubscriptionsTable/__generated__/CustomerSubscriptionsTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCustomerPageNewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateCustomerPageNewQuery = { __typename: 'Query', organization: { __typename: 'Organization', users: Array<{ __typename: 'User', id: string, givenName: string, familyName: string, email: string, roles: Array<Types.Role> }>, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, name: string, createdAt: any, userGivenName?: string | null, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null }, customers: Array<{ __typename: 'PartialCustomer', name: string }> }> | null }, me: { __typename: 'CurrentUser', id: string } };

export type CreateCustomerV2MutationVariables = Types.Exact<{
  input: Types.CustomerCreateInputV2;
}>;


export type CreateCustomerV2Mutation = { __typename: 'Mutation', customerCreateNew: { __typename: 'Customer', id: string, handle: string, name: string, avatarUrl?: string | null } };


export const CreateCustomerPageNewDocument = gql`
    query CreateCustomerPageNew {
  organization {
    users {
      ...CustomerUsersTableUser
    }
    waveSubscriptions(isAssignable: true) {
      ...CustomerSubscriptionsTableSubscription
    }
  }
  me {
    id
  }
}
    ${CustomerUsersTableUserFragmentDoc}
${CustomerSubscriptionsTableSubscriptionFragmentDoc}`;

/**
 * __useCreateCustomerPageNewQuery__
 *
 * To run a query within a React component, call `useCreateCustomerPageNewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerPageNewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCustomerPageNewQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateCustomerPageNewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateCustomerPageNewQuery, CreateCustomerPageNewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateCustomerPageNewQuery, CreateCustomerPageNewQueryVariables>(CreateCustomerPageNewDocument, options);
      }
export function useCreateCustomerPageNewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateCustomerPageNewQuery, CreateCustomerPageNewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateCustomerPageNewQuery, CreateCustomerPageNewQueryVariables>(CreateCustomerPageNewDocument, options);
        }
export type CreateCustomerPageNewQueryHookResult = ReturnType<typeof useCreateCustomerPageNewQuery>;
export type CreateCustomerPageNewLazyQueryHookResult = ReturnType<typeof useCreateCustomerPageNewLazyQuery>;
export type CreateCustomerPageNewQueryResult = ApolloReactCommon.QueryResult<CreateCustomerPageNewQuery, CreateCustomerPageNewQueryVariables>;
export const CreateCustomerV2Document = gql`
    mutation CreateCustomerV2($input: CustomerCreateInputV2!) {
  customerCreateNew(input: $input) {
    id
    handle
    name
    avatarUrl
  }
}
    `;
export type CreateCustomerV2MutationFn = ApolloReactCommon.MutationFunction<CreateCustomerV2Mutation, CreateCustomerV2MutationVariables>;

/**
 * __useCreateCustomerV2Mutation__
 *
 * To run a mutation, you first call `useCreateCustomerV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerV2Mutation, { data, loading, error }] = useCreateCustomerV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomerV2Mutation, CreateCustomerV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomerV2Mutation, CreateCustomerV2MutationVariables>(CreateCustomerV2Document, options);
      }
export type CreateCustomerV2MutationHookResult = ReturnType<typeof useCreateCustomerV2Mutation>;
export type CreateCustomerV2MutationResult = ApolloReactCommon.MutationResult<CreateCustomerV2Mutation>;
export type CreateCustomerV2MutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomerV2Mutation, CreateCustomerV2MutationVariables>;